import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../environments/environment';
import { pageMenus, PageModel } from './config/page-menus';
import { ConnectBackendService } from './service/connect-backend.service';
import { MenuForUserData } from 'src/app/main/system-setting/menu-for-use/menu-for-use.model';

const BASE_URL = environment.api_url

@Injectable({
  providedIn: 'root'
})



export class AuthService {

  apiUrl = BASE_URL

  customPageMenu: BehaviorSubject<PageModel[]>
  customPageMenus = pageMenus

  constructor(private service: ConnectBackendService, private http: HttpClient) {
    this.customPageMenu = new BehaviorSubject<PageModel[]>([]);

  }

  getPermissions(menu_id: number): void {


    this.http.get(`${this.service.url}/settings/menu-custom/permission/${menu_id}`, this.service.getHeadersAut())
      .subscribe((resp: any) => {
        let customMenu: PageModel[] = []
        for (let item of resp) {
          for (let menuLv1 of this.customPageMenus) {
            if (menuLv1.url !== '/home') {
              for (let menuLv2 of menuLv1.submenu) {
                if (menuLv2.url === item.url) {
                  const index = customMenu.findIndex(element => element.title === menuLv1.title)
                  if (index === -1) {

                    let menu: PageModel = {
                      icon: menuLv1.icon,
                      title: menuLv1.title,
                      url: menuLv1.url,
                      caret: menuLv1.caret,
                      submenu: [],
                      hide: menuLv1.hide,
                      state: menuLv1.state,
                      selected: menuLv1.selected,
                      sort:menuLv1.sort
                    }
                    menu.submenu.push(menuLv2)
                    customMenu.push(menu)
                  } else {
                    customMenu[index].submenu.push(menuLv2)
                  }
                }
              }
            }

            if (menuLv1.url === '/home' && menuLv1.url === item.url) {

              customMenu.push(menuLv1)
            }
          }
        }
        customMenu.sort((a, b) => (a.sort < b.sort ? -1 : 1));
        this.customPageMenu.next(customMenu)
      })
  }
}


